import $ from "jquery";
import "./_srci.scss";

import select2 from "select2";

select2({theme: 'bootstrap', width: '100%'});

import {TabulatorFull as Tabulator} from "tabulator-tables-5";
import CustomExtension from "./tabulator/tree-extension";

const autoCompleteFilter = {
  valuesLookup: true,
  clearable: true,
  autocomplete: true,
  allowEmpty: true,
  listOnEmpty: true,
  elementAttributes: {
    placeholder: "Select"
  }
}

const tickCrossParams = {
  tristate: true,
  elementAttributes: {
    "data-tristate": "true",
  }
}
const tickCrossFormatterParams = {
  tickElement: `<span class="icon-success"></span>`,
  crossElement: `<span class="icon-cross"></span>`,
}

const tickCrossFilter = function (headerValue, rowValue) {
  return headerValue === (rowValue === 'true' || rowValue === 'yes' || rowValue === "Yes" || rowValue === 1 || rowValue === "1");
}

let deepMatchHeaderFilterStatusMap = {};
function deepMatchHeaderFilterStatusMapGetter(fieldName, k) {
  return (deepMatchHeaderFilterStatusMap[fieldName] || {})[k];
}
function deepMatchHeaderFilterStatusMapSetter(fieldName, k, v) {
  let fieldMap = deepMatchHeaderFilterStatusMap[fieldName];
  if (fieldMap == null) {
    fieldMap = {};
    deepMatchHeaderFilterStatusMap[fieldName] = fieldMap;
  }
  fieldMap[k] = v;
}

const deepMatchHeaderFilter = CustomExtension.tableTreeCreateDeepMatchHeaderFilter(
  deepMatchHeaderFilterStatusMapGetter,
  deepMatchHeaderFilterStatusMapSetter,
  null,
  'no',
  'properties'
);

const deepMatchHeaderTickCrossFilter = CustomExtension.tableTreeCreateDeepMatchHeaderFilter(
  deepMatchHeaderFilterStatusMapGetter,
  deepMatchHeaderFilterStatusMapSetter,
  tickCrossFilter,
  'no',
  'properties'
);

function deepMatchHeaderFilterIsActualMatch(k) {
  // All fields must match to match the row.
  for (const fieldMap of Object.values(deepMatchHeaderFilterStatusMap)) {
    if (fieldMap[k] != 2) {
      return false;
    }
  }
  return true;
}

let metaData = null;

const formatTitle = (srci) => {
  if (srci.implementationType === 'client') {
    return `${srci.modelName} ${srci.modelVersion}`;
  }
  return `${srci.kinematicType} ${srci.kinematicName} ${srci.kinematicVersion}`;
}

const autoColumnsDefinitions = {
  "no": {
    "title": 'No',
    "formatter": 'plaintext',
    headerFilter: "input",
    headerFilterFunc: deepMatchHeaderFilter,
    width: 60,
    headerFilterFuncParams: {
      columnName: "no",
    },
  },
  "supported": {
    "title": 'Supported',
    "formatter": 'tickCross',
    "headerSort": false,
    "headerFilter": "tickCross",
    formatterParams: tickCrossFormatterParams,
    headerFilterParams: tickCrossParams,
    headerFilterFunc: deepMatchHeaderTickCrossFilter,
    headerFilterFuncParams: {
      columnName: "supported",
    },
  },
  "function": {
    "title": 'Function',
    // "formatter": 'plaintext',
    // "width": 150,
    "headerFilter": "input",
    headerFilterFunc: deepMatchHeaderFilter,
    // headerFilterParams: autoCompleteFilter,
    headerFilterFuncParams: {
      columnName: "function",
    },
  },
  "type": {
    "title": 'Type?',
    "headerSort": false,
    "headerFilter": "input",
    headerFilterFunc: deepMatchHeaderFilter,
    headerFilterFuncParams: {
      columnName: "type",
    },
  },
  "functionGroup": {
    "title": 'Function Group',
    "formatter": 'plaintext',
    "headerSort": false,
    "headerFilter": "list",
    headerFilterFunc: deepMatchHeaderFilter,
    headerFilterParams: autoCompleteFilter,
    headerFilterFuncParams: {
      columnName: "functionGroup",
    },
  },
  "mandatory": {
    "title": 'Mandatory / Optional',
    width: 100,
    "headerSort": false,
    "headerFilter": "list",
    headerFilterFunc: deepMatchHeaderFilter,
    headerFilterParams: autoCompleteFilter,
    headerFilterFuncParams: {
      columnName: "mandatory",
    },
  },
  "name": {
    "title": 'Name',
    "formatter": 'plaintext',
    "headerSort": false,
    "headerFilter": false,
  },
  "detailSubProperty": {
    "title": 'Detail Sub Property',
    "formatter": 'plaintext',
    "headerSort": false,
    "headerFilter": false
  },
  "additionalImplementationInformation": {
    "visible": false,
    "headerFilter": false
  },
  "limitedReleaseFunctionSet": {
    "visible": false,
    "headerFilter": false
  },
  "s0": {
    "title": 'Supported by',
    "formatter": 'tickCross',
    "headerSort": false,
    "headerFilter": "tickCross",
    formatterParams: tickCrossFormatterParams,
    headerFilterParams: tickCrossParams,
    headerFilterFunc: deepMatchHeaderTickCrossFilter,
    headerFilterFuncParams: {
      columnName: "s0",
    },
    titleFormatter(cell) {
      if (metaData !== null) {
        return cell.getValue() + ` ${formatTitle(metaData.product1)}`;
      }
      return cell.getValue();
    },
  },
  "s1": {
    "title": 'Supported by',
    "formatter": 'tickCross',
    "headerSort": false,
    "headerFilter": "tickCross",
    formatterParams: tickCrossFormatterParams,
    headerFilterParams: tickCrossParams,
    headerFilterFunc: deepMatchHeaderTickCrossFilter,
    headerFilterFuncParams: {
      columnName: "s1",
    },
    titleFormatter(cell) {
      if (metaData !== null) {
        return cell.getValue() + ` ${formatTitle(metaData.product2)}`;
      }
      return cell.getValue();
    },
  },
  "uid": {
    "visible": false,
    "headerFilter": false
  },
  "id": {
    "visible": false,
    "headerFilter": false
  },
  "pid": {
    "visible": false,
    "headerFilter": false
  },
  "properties": {
    "visible": false,
    "headerFilter": false
  },
  "listVersion": {
    title: 'List Version',
    "headerFilter": "list",
    headerFilterParams: autoCompleteFilter
  },
  "productSoftwareVersion": {
    title: 'Product Software Version',
    "headerFilter": false,
    // headerFilterParams: autoCompleteFilter
  },
  srciVersion: {
    title: 'SRCI Version',
    "headerFilter": "list",
    headerFilterParams: autoCompleteFilter
  },
  manufacturer: {
    field: 'manufacturer',
    title: 'Manufacturer',
    "headerFilter": "list",
    headerFilterParams: autoCompleteFilter,
    mutator(value, data) {
      if (value.public_name) {
        return value.public_name;
      }
      return value.name;
    }
  },
  srci_type: {
    title: 'Type',
    // "headerFilter": "list",
    // headerFilterParams: autoCompleteFilter
  },
  srci_name: {
    visible: false
  },
  "implementationType": {
    title: 'Implementation Type',
    "headerFilter": "list",
    headerFilterParams: autoCompleteFilter
  },
  "modelName": {
    title: 'Model',
    "headerFilter": false,
  },
  "modelVersion": {
    title: 'Model Version',
    "headerFilter": false,
  },
  "kinematicType": {
    title: 'Kinematic Type',
    "headerFilter": "list",
    headerFilterParams: autoCompleteFilter
  },
  "kinematicName": {
    title: 'Robot controller model name',
    "headerFilter": false,
    // headerFilterParams: autoCompleteFilter
  },
  "kinematicVersion": {
    title: 'Robot controller Firmware Version',
    "headerFilter": false,
  },
  "critical": {
    title: 'Critical Bug or Limitation',
    formatter(cell, formatterParams, onRendered) {
      return cell.getValue() ? '<span class="icon-critical"></span>' : '';
    },
    headerFilterFuncParams: {
      columnName: "critical",
    },
  }
}

document.addEventListener('DOMContentLoaded', () => {

  const form = document.getElementById('srci-search');
  const downloadPDFButton = document.querySelector('[data-tabulator-download="pdf"]');

  const $searchType = $("[name='tx_srci_search[dto][searchType]']");

  const manufacturerSelect = $('#manufacturer');
  const implementationTypeSelect = $('#implementationType');
  const kinematicTypeSelect = $('#kinematicType');
  const controllerNameSelect = $('#controllerName');
  const modelNameSelect = $('#modelName');
  const productSoftwareVersionSelect = $('#productSoftwareVersion');

  const functionNameSelect = $('#functionName');
  const commandParameterSelect = $('#commandParameter');
  const commandParameterValueSelect = $('#commandParameterValue');

  const compareSelect = $('#compare');
  const compareVersionSelect = $('#compareVersion');

  const compareToSelect = $('#compareTo');
  const compareToVersionSelect = $('#compareToVersion');

  const updateSearchUrl = () => {
    const uri = new URL(form.action);
    uri.searchParams.delete('cHash')
    uri.searchParams.append('tx_srci_search[dto][searchType]', $searchType.parent().find(':checked').val());
    uri.searchParams.append('tx_srci_search[dto][manufacturer]', manufacturerSelect.val());
    uri.searchParams.append('tx_srci_search[dto][implementationType]', implementationTypeSelect.val());
    uri.searchParams.append('tx_srci_search[dto][kinematicType]', kinematicTypeSelect.val());
    uri.searchParams.append('tx_srci_search[dto][controllerName]', controllerNameSelect.val());
    // uri.searchParams.append('tx_srci_search[dto][controllerVersion]', controllerVersionSelect.val());
    uri.searchParams.append('tx_srci_search[dto][modelName]', modelNameSelect.val());
    // uri.searchParams.append('tx_srci_search[dto][modelVersion]', modelVersionSelect.val());
    uri.searchParams.append('tx_srci_search[dto][productSoftwareVersion]', productSoftwareVersionSelect.val());
    uri.searchParams.append('tx_srci_search[dto][functionName]', functionNameSelect.val());
    uri.searchParams.append('tx_srci_search[dto][commandParameter]', commandParameterSelect.val());
    uri.searchParams.append('tx_srci_search[dto][commandParameterValue]', commandParameterValueSelect.val());
    uri.searchParams.append('tx_srci_search[dto][compare]', compareSelect.val());
    uri.searchParams.append('tx_srci_search[dto][compareVersion]', compareVersionSelect.val());
    uri.searchParams.append('tx_srci_search[dto][compareTo]', compareToSelect.val());
    uri.searchParams.append('tx_srci_search[dto][compareToVersion]', compareToVersionSelect.val());
    uri.searchParams.append('tx_srci_search[dto][expanded]', expandCheckbox.checked ? '1' : '0');
    document.dispatchEvent(new CustomEvent('srci:update-search-url', { detail: uri }));
    window.history.replaceState(null, '', uri.toString());
  }

  const parseUrlByType = (url, type) => {
    const uri = new URL(url);
    uri.searchParams.delete('cHash')
    uri.searchParams.append('tx_srci_json[type]', type);
    uri.searchParams.append('tx_srci_json[manufacturer]', manufacturerSelect.val());
    uri.searchParams.append('tx_srci_json[implementationType]', implementationTypeSelect.val());
    uri.searchParams.append('tx_srci_json[kinematicType]', kinematicTypeSelect.val());
    uri.searchParams.append('tx_srci_json[controllerName]', controllerNameSelect.val());
    // uri.searchParams.append('tx_srci_json[controllerVersion]', controllerVersionSelect.val());
    uri.searchParams.append('tx_srci_json[modelName]', modelNameSelect.val());
    // uri.searchParams.append('tx_srci_json[modelVersion]', modelVersionSelect.val());
    uri.searchParams.append('tx_srci_json[productSoftwareVersion]', productSoftwareVersionSelect.val());
    uri.searchParams.append('tx_srci_json[functionName]', functionNameSelect.val());
    uri.searchParams.append('tx_srci_json[commandParameter]', commandParameterSelect.val());
    uri.searchParams.append('tx_srci_json[commandParameterValue]', commandParameterValueSelect.val());
    uri.searchParams.append('tx_srci_json[compare]', compareSelect.val());
    uri.searchParams.append('tx_srci_json[compareVersion]', compareVersionSelect.val());
    uri.searchParams.append('tx_srci_json[compareTo]', compareToSelect.val());
    uri.searchParams.append('tx_srci_json[compareToVersion]', compareToVersionSelect.val());
    return uri.toString();
  }

  const optionTemplate = function (state) {
    if (!state.id) {
      return state.text;
    }
    return $(`<span class="select2-results__option">${state.text}</span>`)
  }

  const common = {
    allowClear: true,
    placeholder: 'Select an option',
    theme: 'bootstrap',
    width: '100%',
    templateSelection: optionTemplate,
    templateResult: optionTemplate,
    matcher(params, data){
      if ($.trim(params.term) === '') {
        return data;
      }

      if (typeof data.text === 'undefined') {
        return null;
      }

      if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1
        || data?.info?.toLowerCase().indexOf(params.term.toLowerCase()) > -1
      ) {
        return data;
      }

      return null;
    }
  }

  const displayVersion = (version) => {
    $('#srci_version').text("Min. Firmware Version: " + version);
  }
  const resetVersion = () => {
    $('#srci_version').text('');
  }

  const fetchRemoteData = ($select) => {
    const currentValue = $select.val();
    let url = $select.data('remote');
    let action = $select.data('action');

    $select.prop('disabled', true);
    $.ajax(parseUrlByType(url, action))
      .done(function (result) {
        $select.find('option').remove();
        result.forEach(r => {
          const opt = new Option(r.text, r.id, false, r.id == currentValue);
          $select.append(opt);
          if (r.model_version) {
            opt.setAttribute('data-version', r.model_version);
            r.id == currentValue && displayVersion(r.model_version);
          }
          if (r.kinematic_version) {
            opt.setAttribute('data-version', r.kinematic_version);
            r.id == currentValue && displayVersion(r.kinematic_version);
          }
        });
        $select.trigger('select2.change');
        $select.prop('disabled', false);
        if (currentValue === '' && result.length === 2) {
          const r = result[1];
          $select
            .val(r.id)
            .trigger('change')
          ;
          if (r.model_version) {
            displayVersion(r.model_version);
          }
          if (r.kinematic_version) {
            displayVersion(r.kinematic_version);
          }
        } else if (currentValue === "") {
          setTimeout(function() {
            $select.select2("open");
          }, 300);
        }
        if (result.length === 0) {
          $select.prop('disabled', true);
          $select.prop('placeholder', '-');
        }
      })
  }

  //region manufacturer select

  manufacturerSelect.select2(common);
  implementationTypeSelect.select2(common);
  kinematicTypeSelect.select2(common);
  controllerNameSelect.select2(common);
  // controllerVersionSelect.select2(common);
  modelNameSelect.select2(common);
  // modelVersionSelect.select2(common);
  productSoftwareVersionSelect.select2(common);

  productSoftwareVersionSelect.on('select2:select', function (e) {
    if (e.params.data.element.getAttribute('data-version')) {
      displayVersion(e.params.data.element.getAttribute('data-version'));
    }
  });

  fetchRemoteData(manufacturerSelect);

  if (manufacturerSelect.val() !== "") {
    implementationTypeSelect.closest('[data-srci-field]').show();
    fetchRemoteData(implementationTypeSelect);

    if (implementationTypeSelect.val() === 'interpreter') {
      kinematicTypeSelect.closest('[data-srci-field]').show();
      fetchRemoteData(kinematicTypeSelect);
      if (kinematicTypeSelect.val() !== '') {
        controllerNameSelect.closest('[data-srci-field]').show();
        fetchRemoteData(controllerNameSelect);
      }
      if (controllerNameSelect.val() !== '') {
        productSoftwareVersionSelect.closest('[data-srci-field]').show();
        fetchRemoteData(productSoftwareVersionSelect);
      }
    }

    if (implementationTypeSelect.val() === 'client') {
      modelNameSelect.closest('[data-srci-field]').show();
      fetchRemoteData(modelNameSelect);
      if (modelNameSelect.val() !== '') {
        productSoftwareVersionSelect.closest('[data-srci-field]').show();
        fetchRemoteData(productSoftwareVersionSelect);
      }
    }
  }

  manufacturerSelect.on('change', function () {
    implementationTypeSelect.val(null).trigger('change');
    clearTable();
    updateSearchUrl();
    if (manufacturerSelect.val() !== "") {
      implementationTypeSelect.closest('[data-srci-field]').show();
      fetchRemoteData(implementationTypeSelect);
    } else {
      implementationTypeSelect.closest('[data-srci-field]').hide();
    }
  });
  implementationTypeSelect.on('change', function() {
    modelNameSelect.val(null).trigger('change');
    kinematicTypeSelect.val(null).trigger('change');
    clearTable();
    updateSearchUrl();

    if (implementationTypeSelect.val() === 'interpreter') {
      kinematicTypeSelect.closest('[data-srci-field]').show();
      fetchRemoteData(kinematicTypeSelect);
    }
    else if (implementationTypeSelect.val() === 'client') {
      modelNameSelect.closest('[data-srci-field]').show();
      fetchRemoteData(modelNameSelect);
    }
    else {
      kinematicTypeSelect.closest('[data-srci-field]').hide();
      modelNameSelect.closest('[data-srci-field]').hide();
    }
  });

  kinematicTypeSelect.on('change', function() {
    controllerNameSelect.val(null).trigger('change');
    clearTable();
    updateSearchUrl();
    if (kinematicTypeSelect.val() !== '') {
      controllerNameSelect.closest('[data-srci-field]').show();
      fetchRemoteData(controllerNameSelect);
    } else {
      controllerNameSelect.closest('[data-srci-field]').hide();
    }
  });
  controllerNameSelect.on('change', function() {
    productSoftwareVersionSelect.val(null).trigger('change');
    clearTable();
    updateSearchUrl();
    if (controllerNameSelect.val() !== '') {
      productSoftwareVersionSelect.closest('[data-srci-field]').show();
      fetchRemoteData(productSoftwareVersionSelect);
    } else {
      productSoftwareVersionSelect.closest('[data-srci-field]').hide();
    }
  });
  productSoftwareVersionSelect.on('change', function () {
    if (this.value === "") {
      resetVersion();
      return;
    }
    updateSearchUrl();
    form.dispatchEvent(new CustomEvent('srci:show'));
  });

  modelNameSelect.on('change', function() {
    productSoftwareVersionSelect.val(null).trigger('change');
    clearTable();
    updateSearchUrl();
    if (modelNameSelect.val() !== '') {
      productSoftwareVersionSelect.closest('[data-srci-field]').show();
      fetchRemoteData(productSoftwareVersionSelect);
    } else {
      productSoftwareVersionSelect.closest('[data-srci-field]').hide();
    }
  });

  productSoftwareVersionSelect.on('change', function () {
    if (this.value === "") {return;}
    updateSearchUrl();
    form.dispatchEvent(new CustomEvent('srci:show'));
  });

  //endregion

  // region function select
  functionNameSelect.select2(common);
  commandParameterSelect.select2(common);
  commandParameterValueSelect.select2(common);

  fetchRemoteData(functionNameSelect);

  if (functionNameSelect.val() !== "") {
    commandParameterSelect.closest('[data-srci-field]').show();
    fetchRemoteData(commandParameterSelect);
    if (commandParameterSelect.val() !== "") {
      commandParameterValueSelect.closest('[data-srci-field]').show();
      fetchRemoteData(commandParameterValueSelect);
    }
  }

  functionNameSelect.on('change', function() {
    commandParameterSelect.val(null).trigger('change');
    updateSearchUrl();
    if (this.value !== "") {
      commandParameterSelect.closest('[data-srci-field]').show();
      fetchRemoteData(commandParameterSelect);
    } else {
      commandParameterSelect.closest('[data-srci-field]').hide();
    }
    form.dispatchEvent(new CustomEvent('srci:show'));
  });
  commandParameterSelect.on('change', function() {
    commandParameterValueSelect.val(null).trigger('change');
    updateSearchUrl();
    if (this.value !== "") {
      commandParameterValueSelect.closest('[data-srci-field]').show();
      fetchRemoteData(commandParameterValueSelect);
    } else {
      commandParameterValueSelect.closest('[data-srci-field]').hide();
    }
    form.dispatchEvent(new CustomEvent('srci:show'));
  });
  commandParameterValueSelect.on('change', function() {
    if (this.value === "") {return;}
    updateSearchUrl();
    form.dispatchEvent(new CustomEvent('srci:show'));
  });

  // endregion

  // region compare
  compareSelect.select2(common);
  compareVersionSelect.select2(common);
  compareToSelect.select2(common);
  compareToVersionSelect.select2(common);

  fetchRemoteData(compareSelect);
  // fetchRemoteData(compareToSelect);

  if (compareSelect.val() !== "") {
    fetchRemoteData(compareVersionSelect);
  } else {
    compareVersionSelect.prop('disabled', true);
  }
  if (compareVersionSelect.val() !== "") {
    fetchRemoteData(compareToSelect);
  } else {
    compareToSelect.prop('disabled', true);
  }
  if (compareToSelect.val() !== "") {
    fetchRemoteData(compareToVersionSelect);
  } else {
    compareToVersionSelect.prop('disabled', true);
  }

  compareSelect.on('change', function() {
    compareVersionSelect.val(null).trigger('change');
    updateSearchUrl();
    if (this.value !== "") {
      fetchRemoteData(compareVersionSelect)
    } else {
      compareVersionSelect.prop('disabled', true);
    }
  });

  compareVersionSelect.on('change', function() {
    compareToSelect.val(null).trigger('change');
    updateSearchUrl();
    if (this.value !== "") {
      fetchRemoteData(compareToSelect)
    } else {
      compareToSelect.prop('disabled', true);
    }
  });

  compareToSelect.on('change', function() {
    compareToVersionSelect.val(null).trigger('change');
    updateSearchUrl();
    if (this.value !== "") {
      fetchRemoteData(compareToVersionSelect)
    } else {
      compareToVersionSelect.prop('disabled', true);
    }
  });

  compareToVersionSelect.on('change', function() {
    updateSearchUrl();
    if (this.value === "") {
      // compareToVersionSelect.prop('disabled', true);
      return;
    }
    form.dispatchEvent(new CustomEvent('srci:show'));
  });

  // endregion

  // region table setup
  const tableRoot = document.getElementById('srci-table');
  const expandCheckbox = document.getElementById('expanded');
  const reset = document.getElementById('reset');

  reset.addEventListener('click', function(event) {
    event.preventDefault();
    const searchParams = new URLSearchParams("");
    searchParams.append('tx_srci_search[dto][searchType]', $searchType.parent().find(':checked').val());
    window.location.search = searchParams;

    table?.clearFilter(true);
    deepMatchHeaderFilterStatusMap = {};
  })

  let abortControllerData;
  let tableLoading = false;

  const ajaxRequestFunc = function(url, config, params) {
    if (abortControllerData) {
      abortControllerData.abort();
    }
    abortControllerData = new AbortController();
    config.signal = abortControllerData.signal;
    var contentType;
    return new Promise((resolve, reject) => {
      //set url
      url = this.urlGenerator.call(this.table, url, config, params);
      //set body content if not GET request
      if(config.method.toUpperCase() != "GET"){
        contentType = typeof this.table.options.ajaxContentType === "object" ?  this.table.options.ajaxContentType : this.contentTypeFormatters[this.table.options.ajaxContentType];
        if(contentType){
          for(var key in contentType.headers){
            if(!config.headers){
              config.headers = {};
            }
            if(typeof config.headers[key] === "undefined"){
              config.headers[key] = contentType.headers[key];
            }
          }
          config.body = contentType.body.call(this, url, config, params);
        }else{
          console.warn("Ajax Error - Invalid ajaxContentType value:", this.table.options.ajaxContentType);
        }
      }
      if(url){
        //configure headers
        if(typeof config.headers === "undefined"){
          config.headers = {};
        }
        if(typeof config.headers.Accept === "undefined"){
          config.headers.Accept = "application/json";
        }
        if(typeof config.headers["X-Requested-With"] === "undefined"){
          config.headers["X-Requested-With"] = "XMLHttpRequest";
        }
        if(typeof config.mode === "undefined"){
          config.mode = "cors";
        }
        if(config.mode == "cors"){
          if(typeof config.headers["Origin"] === "undefined"){
            config.headers["Origin"] = window.location.origin;
          }
          if(typeof config.credentials === "undefined"){
            config.credentials = 'same-origin';
          }
        }else{
          if(typeof config.credentials === "undefined"){
            config.credentials = 'include';
          }
        }
        //send request
        fetch(url, config)
          .then((response)=>{
            if(response.ok) {
              response.json()
                .then((data)=>{
                  resolve(data);
                }).catch((error)=>{
                reject(error);
                console.warn("Ajax Load Error - Invalid JSON returned", error);
              });
            }else{
              console.error("Ajax Load Error - Connection Error: " + response.status, response.statusText);
              reject(response);
            }
          })
          .catch((error)=>{
            if (error.name !== "AbortError") {
              console.error("Ajax Load Error - Connection Error: ", error);
            }
            reject(error);
          });
      }else{
        console.warn("Ajax Load Error - No URL Set");
        resolve([]);
      }
    });
  }

  const tableConfigurations = {
    'function': {
      height: '550px',
      layout:"fitColumns",
      autoColumns: true,
      index: 'no',
      dataTree: true,
      dataTreeFilter: true,
      dataTreeChildField: 'properties',
      dataTreeElementColumn: 'function',
      headerFilterPlaceholder: '...',
      ajaxRequestFunc,
      autoColumnsDefinitions,
      ajaxResponse(url, params, response) {
        metaData = response.meta;
        return response.data;
      },
    },
    'compare': {
      height: '550px',
      layout:"fitColumns",
      autoColumns: true,
      index: 'no',
      dataTree: true,
      dataTreeFilter: true,
      dataTreeChildField: 'properties',
      dataTreeElementColumn: 'function',
      headerFilterPlaceholder: '...',
      ajaxResponse(url, params, response) {
        metaData = response.meta;
        return response.data;
      },
      autoColumnsDefinitions: {
        ...autoColumnsDefinitions,
        "supported": {
          visible: false,
        }
      },
      ajaxRequestFunc,
    },
    'manufacturer': {
      height: '550px',
      autoColumns: true,
      index: 'uid',
      layout:"fitDataFill",
      headerFilterPlaceholder: '...',
      groupBy: 'manufacturer',
      groupStartOpen: false,
      groupHeader(value, count, data, group) {
        return value + "<span style='color:#d00; margin-left:10px;'>(" + count + ")</span>";
      },
      ajaxRequestFunc,
      autoColumnsDefinitions,
    }
  }
  let table = null;

  const loadTableData = () => {
    if (table === null) {
      downloadPDFButton.classList.add('disabled');
      return;
    }
    if (tableLoading || table.initialized === false) {return;}

    table?.clearFilter(true);
    deepMatchHeaderFilterStatusMap = {};
    const url = new URL(tableRoot.dataset['action']);
    url.searchParams.delete('cHash');
    url.searchParams.set('tx_srci_results[action]', $searchType.parent().find(':checked').val());
    url.searchParams.append('tx_srci_results[dto][manufacturer]', manufacturerSelect.val());
    url.searchParams.append('tx_srci_results[dto][implementationType]', implementationTypeSelect.val());
    url.searchParams.append('tx_srci_results[dto][kinematicType]', kinematicTypeSelect.val());
    url.searchParams.append('tx_srci_results[dto][controllerName]', controllerNameSelect.val());
    // url.searchParams.append('tx_srci_results[dto][controllerVersion]', controllerVersionSelect.val());
    url.searchParams.append('tx_srci_results[dto][modelName]', modelNameSelect.val());
    // url.searchParams.append('tx_srci_results[dto][modelVersion]', modelVersionSelect.val());
    url.searchParams.append('tx_srci_results[dto][productSoftwareVersion]', productSoftwareVersionSelect.val());
    url.searchParams.append('tx_srci_results[dto][functionName]', functionNameSelect.val());
    url.searchParams.append('tx_srci_results[dto][commandParameter]', commandParameterSelect.val());
    url.searchParams.append('tx_srci_results[dto][commandParameterValue]', commandParameterValueSelect.val());
    url.searchParams.append('tx_srci_results[dto][compare]', compareSelect.val());
    url.searchParams.append('tx_srci_results[dto][compareVersion]', compareVersionSelect.val());
    url.searchParams.append('tx_srci_results[dto][compareTo]', compareToSelect.val());
    url.searchParams.append('tx_srci_results[dto][compareToVersion]', compareToVersionSelect.val());
    url.searchParams.append('tx_srci_results[dto][expanded]', expandCheckbox.checked);
    table.setData(url.toString(), true, 'POST');
  }

  const clearTable = () => {
    if (table !== null) {
      table.clearData();
    }
  }

  const downloadPdfAction = async (event) => {
    event.preventDefault();
    if (table) {
      const jsPDF  = (await import("jspdf")).default;
      await import("jspdf-autotable");
      window['jspdf'] = {jsPDF};
      table.download('pdf', `SRCI_table_export_${Math.floor(Date.now() / 1000)}.pdf`, {
        autoTable: function(doc) {
          doc.putTotalPages = '{total_pages_count_string}';
          return {
            theme: 'plain',
            showHead: 'firstPage',
            showFoot: 'lastPage',
            styles: {
              textColor: '#414552',
              fontSize: 8,
              cellPadding: 8,
            },
            headStyles: {
              fillColor: '#F5F6FC'
            },
            bodyStyles: {
              lineColor: '#414552',
              lineWidth: {bottom: 1}
            },
            didDrawPage: function(data) {
              // Footer
              var str = 'Page ' + doc.internal.getNumberOfPages()
              doc.setFontSize(10)
              var pageSize = doc.internal.pageSize
              var pageHeight = pageSize.getHeight()
              doc.text('© Copyright PNO ' + (new Date().getFullYear()) + ' - All Rights Reserved', data.settings.margin.left, pageHeight - 10, {align: 'left'})
              doc.text(str, doc.internal.pageSize.getWidth() - data.settings.margin.right, pageHeight - 10, {align: 'right'})
            }
          }
        }
      });
    }
  }

  const handleExpand = (checked) => {
    if (table !== null) {
      if ($searchType.parent().find(':checked').val() !== "manufacturer") {
        if (checked) {
          CustomExtension.tableTreeExpand(
            table,
            /*rows*/ null,
            /*refresh*/ true,
            /*reformat*/ true
          );
        } else {
          CustomExtension.tableTreeCollapse(
            table,
            /*rows*/ null,
            /*unlessSelected*/ false,
            /*refresh*/ true,
            /*reformat*/ true
          );
        }
      } else {
        table.blockRedraw();
        if (checked) {
          table.getGroups().forEach(group => {group.show();})
        } else {
          table.getGroups().forEach(group => {group.hide();})
        }
        table.restoreRedraw();
      }
    }
  }

  const setupTable = (element, searchType) => {
    if (table !== null) {
      table.destroy();
    }
    table = new Tabulator(element, {
      ...tableConfigurations[searchType],
      dataTreeStartExpanded: true,
      rowFormatter(row) {
        let selectionDisabled = !deepMatchHeaderFilterIsActualMatch(row.getIndex());
        if (selectionDisabled) {
          row.getElement().classList.add("disabled");
          row.getElement().classList.remove("filtered");
        } else {
          row.getElement().classList.add("filtered");
          row.getElement().classList.remove("disabled");
        }
      }
    });
    table.on('dataLoading', () => {
      metaData = null;
      tableLoading = true;
    })
    table.on('dataLoaded', () => {
      tableLoading = false;
    })
    table.on('dataLoadError', () => {
      tableLoading = false;
    })
    table.on('dataLoaded', (data) => {
      if(Array.isArray(data)) {
        downloadPDFButton.removeEventListener('click', downloadPdfAction);
        downloadPDFButton.addEventListener('click', downloadPdfAction);
        downloadPDFButton.classList.remove('disabled');
      }
    });
    table.on("dataProcessed", function(){
      lookForCriticalBugs();
      handleExpand(expandCheckbox.checked);
      table.redraw();
    });
    table.on("dataFiltering", function(filters) {
      const table1 = this;

      /*
       When dataTreeFilter is set to true (default), dataFiltering and dataFiltered
       will be called consecutively for each set of filtered child rows.

       Note that the pattern is:
       - dataFiltering, dataFiltered,
         dataFiltering, dataFiltered,
         ...,
         dataFiltering, dataFiltered
       NOT:
       - dataFiltering, dataFiltering, dataFiltering,
         ...,
         dataFiltered, dataFiltered, dataFiltered

       (So, it's hard to detect the initial filtering event,
        since table.modules.filter.changed is true all the way too)

       To work around this, we always set table.modules.filter.changed = false
       in the dataFiltered callback: at least the first dataFiltering event where it's
      true will be the first one of the tree.
      */

      if (table1.modules.filter.changed) {
        // CustomExtension.tableTreeExpand(table, /*rows*/ null, /*refresh*/ false);
        deepMatchHeaderFilterStatusMap = {};
      }
    });
    table.on("dataFiltered", function(filters, rows) {
      // Here "rows" is an array RowComponents
      const table1 = this;
      for (let row of rows) {
        row.reformat();
      }
      /*
       We clear the "changed" flag, otherwise it will still be considered
       a new changed for all the dataFiltering/dataFiltered calls for
       children in the tree.
       */
      table1.modules.filter.changed = false;
    });
  }

  setupTable(tableRoot, $searchType.parent().find(':checked').val());

  $searchType.each(function () {
    $(this).on('change', function () {
      $searchType.each(function() { $(this.dataset['target']).addClass('hidden')})
      $(this.dataset['target']).removeClass('hidden');
      updateSearchUrl();
      setupTable(tableRoot, this.value);
      if (
        // controllerVersionSelect.val() !== "" ||
        // modelVersionSelect.val() !== "" ||
        productSoftwareVersionSelect.val() !== "" ||
        functionNameSelect.val() !== "" ||
        commandParameterSelect.val() !== "" ||
        commandParameterValueSelect.val() !== ""
      ) {
        form.dispatchEvent(new CustomEvent('srci:show'));
      }
    });
  });

  form.addEventListener('srci:show', function () {
    if (!table.initialized) {
      table.on('tableBuilt', () => {
        loadTableData();
      });
    } else {
      loadTableData();
    }
  });


  expandCheckbox.addEventListener('change', function (event) {
    updateSearchUrl();
    handleExpand(event.target.checked);
  });

  if (productSoftwareVersionSelect.val() !== "") {
    form.dispatchEvent(new CustomEvent('srci:show'));
  }
  if (compareToVersionSelect.val() !== "") {
    form.dispatchEvent(new CustomEvent('srci:show'));
  }

  // endregion

  // region known bugs
  const knownBugs = document.querySelector('.known-bugs');
  const knownBugsHeader = knownBugs.querySelector('.known-bugs-header');
  const knownBugsContainer = knownBugs.querySelector('.known-bugs-container');
  const knownBugsShowAll = knownBugs.querySelector('.known-bugs-show-all');

  knownBugsShowAll.addEventListener('click', evt => {
    evt.preventDefault();
    if (knownBugs.classList.contains('show-all')) {
      knownBugs.classList.remove('show-all');
    } else {
      knownBugs.classList.add('show-all');
      knownBugs.classList.add('open');
    }
  });

  knownBugsHeader.addEventListener('click', function (event){
    if (knownBugs.classList.contains('active')) {
      knownBugs.classList.toggle('open');
    }
    if (knownBugs.classList.contains('show-all')) {
      knownBugs.classList.remove('show-all');
    }
  });

  let bugListLoaded = 'pending';
  let bugList = new Map();
  const knownBugsPromise = fetch(knownBugs.dataset['remoteUrl'])
    .then(r => r.json())
    .then(r => {
      bugListLoaded = 'loaded';
      const parsedList = [];
      r.forEach(bug => {
        bug.criteria.forEach(criteria => {
          parsedList.push({
            ...bug,
            criteria: criteria
          });
        })
      });
      document.dispatchEvent(new CustomEvent('srci:known-bugs-loaded', { detail: {list: parsedList} }));
    }).catch(e => {
    console.error(e);
    bugListLoaded = 'error';
  });

  const getSearchParamsFromSearchUrl = () => {
    const searchType = $searchType.parent().find(':checked').val();
    let searchParams = {searchType};
    const manufacturer = manufacturerSelect.val();
    const implementationType = implementationTypeSelect.val();
    const productSoftwareVersion = productSoftwareVersionSelect.val();
    const functionName = functionNameSelect.val();
    const commandParameter = commandParameterSelect.val();
    const commandParameterValue = commandParameterValueSelect.val();
    const compare = compareSelect.val();
    const compareVersion = compareVersionSelect.val();
    const compareTo = compareToSelect.val();
    const compareToVersion = compareToVersionSelect.val();
    switch (searchType) {
      case 'function':
        searchParams = {...searchParams, manufacturer};
        if (implementationType === "client") {
          const modelName = modelNameSelect.val();
          searchParams = {...searchParams, modelName, productSoftwareVersion, implementationType};
        }
        if (implementationType === "interpreter") {
          const kinematicType = kinematicTypeSelect.val();
          const kinematicName = controllerNameSelect.val();
          searchParams = {...searchParams, kinematicType, kinematicName, productSoftwareVersion, implementationType};
        }
        break;
      case 'manufacturer':
        searchParams = {...searchParams, functionName, commandParameter, commandParameterValue};
        break;
      case 'compare':
        searchParams = {...searchParams, compare, compareVersion, compareTo, compareToVersion};
        break;
    }
    return searchParams;
  }

  function resolve(path, obj=self, separator='.') {
    const properties = Array.isArray(path) ? path : path.split(separator)
    return properties.reduce((prev, curr) => prev?.[curr], obj)
  }

  function criteriaMatch({searchParams, property}) {
    let [keyB, valueB] = property;

    if ((keyB === "compare" || keyB === "compareTo" || keyB === "manufacturer")) {
      return valueB.some(m => Number.parseInt(searchParams[keyB]) === m.id);
    }
    if (keyB === "compareVersion" || keyB === "compareToVersion") {
      keyB = "productSoftwareVersion";
    }
    // if (keyB === "properties" && a.properties.length > 0 && Array.isArray(valueB)) {
    //   return a.properties.some(p => valueB.find(i => i.no === p.no));
    // }
    return resolve(keyB, searchParams) == valueB;
  }

  // eslint-disable-next-line no-unused-vars
  function matchRow(row, searchParams, criteria, element) {
    const tableRowData = row.getData();
    let shouldMatchAgainstTableData = {
      no: tableRowData.no,
      properties: tableRowData.properties,
    };
    if (metaData) {
      if (searchParams.compareVersion !== "") {
        shouldMatchAgainstTableData = {
          ...shouldMatchAgainstTableData,
          productSoftwareVersion: metaData.product1.productSoftwareVersion,
          srciVersion: metaData.product1.srciVersion,
          implementationType: metaData.product1.implementationType,
          modelName: metaData.product1.modelName,
          modelVersion: metaData.product1.modelVersion,
          kinematicType: metaData.product1.kinematicType,
          kinematicName: metaData.product1.kinematicName,
          kinematicVersion: metaData.product1.kinematicVersion,
          controllerVersion: metaData.product1.controllerVersion,
          controllerName: metaData.product1.controllerName,
          manufacturer: metaData.product1.manufacturer,
        }
        shouldMatchAgainstTableData = Object.entries(shouldMatchAgainstTableData);
        // eslint-disable-next-line no-unused-vars
        const strongMatch = shouldMatchAgainstTableData.every(e => criteriaMatch(criteria, e));
        // eslint-disable-next-line no-unused-vars
        const weakMatch = shouldMatchAgainstTableData.some(e => criteriaMatch(criteria, e));
        // console.log({strongMatch, weakMatch, no: tableRowData.no})
      }
    }
    const children = row.getTreeChildren();
    if (children) {
      children.forEach(child => { matchRow(child, searchParams, criteria, element)});
    }
  }

  const lookForCriticalBugs = async () => {
    await knownBugsPromise;
    const searchParams = getSearchParamsFromSearchUrl();
    let matchCount = 0;

    const tableRows = table ? table.getRows() : null;

    bugList.forEach((bug, element) => {
      let bugMatchCount = 0;
      let match;
      let strongMatch = false;
      let weakMatch = false;
      const criteria = Object.entries(bug.criteria)
        .filter(e => e[0] !== 'properties')
        .filter(e => e[1] !== "" && e[1] !== null && e[1] !== undefined && e[1].length !== 0);
      const hasManufacturer = Array.isArray(bug.criteria.manufacturer) && bug.criteria.manufacturer.length > 0;
      if (hasManufacturer) {
        const isSameManufacturer = criteriaMatch({searchParams, property: ["manufacturer", bug.criteria.manufacturer]});
        if (isSameManufacturer) {
          // strong match, all properties must match
          strongMatch = criteria.every(e => criteriaMatch({searchParams, property: e}));
          // weak match, only some properties should match
          weakMatch = criteria.some(e => criteriaMatch({searchParams, property: e}));
        }
      }
      switch (searchParams.searchType) {
        case 'manufacturer':
        case 'function':
        case 'compare':
          if (strongMatch || weakMatch) {
            const properties = bug.criteria.properties;
            if (properties && properties.length) {
              match = true;
              if (table && table.initialized) {
                const _helper = (row) => {
                  if(properties.some(p => p.no === row.getData().no)) {
                    row.update({"critical": 1});
                  }
                  row.getTreeChildren().forEach(_helper);
                }
                tableRows.forEach(_helper);
              }
            }
          } else {
            if (!hasManufacturer) {
              match = criteria.some(property => criteriaMatch({searchParams: {...metaData}, property}))
            }
          }
          break;
      }
      if (match) {
        // console.log(match, bug.criteria, searchParams, metaData)
        bugMatchCount++;
      }
      // const strongCriteriaMatch = shouldMatchAgainstSearchParams.every(e => criteriaMatch(criteria, e));
      // const weakCriteriaMatch = shouldMatchAgainstSearchParams.some(e => criteriaMatch(criteria, e));
      //
      // if (strongCriteriaMatch || weakCriteriaMatch) {
      //   bugMatchCount++;
      // }
      // if (tableRows && tableRows.length > 0) {
      //   tableRows.forEach((row) => {
      //     matchRow(row, searchParams, criteria, element);
      //   })
      // }

      if (bugMatchCount > 0) {
        element.classList.add('match');
        matchCount++;
      } else {
        element.classList.remove('match');
      }
    });
    if (matchCount > 0 && Object.entries(searchParams).length > 1) {
      knownBugs.classList.add('active');
    } else {
      knownBugs.classList.remove('show-all');
      knownBugs.classList.remove('active');
      knownBugs.classList.remove('open');
    }
  }

  document.addEventListener('srci:update-search-url', () => {
    lookForCriticalBugs();
  });

  /** @param s {String} **/
  function camelCaseToWords(s) {
    const result = s.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  document.addEventListener('srci:known-bugs-loaded', (event) => {
    const {list} = event.detail;
    if (bugListLoaded === "loaded") {
      list.forEach(bug => {
        const template = `
          <div class="known-bugs-item-criteria">${Object.entries(bug.criteria).filter(c => {
            if (Array.isArray(c[1])) {
              return c[1].length > 0;
            }
            return c[1] != "";
        }).map(([name, value]) => {
            if (name === "manufacturer") {
              value = '[' + value.map(m => `${m.name}`).join(' ][ ') + ']';
            }
            if (name === "properties") {
              value = '[' + value.map(p => `${p.no},${p.function},${p.functionGroup}`).join(' ][ ') + ']'
            }
            return `<div><strong>${camelCaseToWords(name)}</strong> ${value}</div>`
        })}</div>
          <div class="known-bugs-item-desciprtion">${bug.description}</div>
         `;
        const element = document.createElement('div');
        element.classList.add('known-bugs-item');
        element.innerHTML = template;
        knownBugsContainer.append(element);
        bugList.set(element, bug);
      });
      lookForCriticalBugs()
    }
  });

  // endregion

});
